import {
  QSetReviewMainTaskViewQuestionNavigator,
  QSetReviewMainTaskViewQuestionSection,
  QsetReviewMainTaskViewQuestionReviewResult,
} from '@exam-management/qset-review-view-question';
import { Flex } from '@shared/components';

export default function ExamDetailsPage() {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(6),
          padding: theme.spacing(6),
        })}
      >
        <QSetReviewMainTaskViewQuestionSection />
        <QsetReviewMainTaskViewQuestionReviewResult />
      </Flex>
      <QSetReviewMainTaskViewQuestionNavigator />
    </Flex>
  );
}
